



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PaymentState from '@/models/Accounts/Shared/Payments/PaymentState';

@Component({ name: 'PaymentState' })
export default class extends SaascadaVue {

    @Prop({ required: true })
    status: PaymentState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.status) {
            case PaymentState.PendingApproval:
            case PaymentState.Scheduled:
            case PaymentState.Processing:
            case PaymentState.MonitoringHeld:
                color = "warning--text";
                break;
            case PaymentState.Accepted:
            case PaymentState.Completed:
            case PaymentState.Submitted:
                color = "success--text";
                break;
            case PaymentState.UserCancelled:
            case PaymentState.UserRejected:
            case PaymentState.Rejected:
            case PaymentState.Failed:
            case PaymentState.MonitoringRejected:
                color = "error--text";
                break;
            default:
                color = "grey-text";
                break;
        }
        return color;
    }

}
